/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_Discard_DescriptionInputs */



/**
* | output |
* | --- |
* | "The instructions you edited have not been saved." |
*
* @param {Project_Instructions_Discard_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_discard_description = /** @type {((inputs?: Project_Instructions_Discard_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_Discard_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die bearbeiteten Anweisungen wurden noch nicht gespeichert.")
	return /** @type {LocalizedString} */ ("The instructions you edited have not been saved.")
});